import axios from 'axios'
import { setLocalStorage,getLocalStorage,removeToken,removeAllLocalStorage } from '@/utils/auth'

// import { formatLang } from './format'

import fingerprintjs from '@fingerprintjs/fingerprintjs'
// import { SignatureGenerator } from './signatureGenerator'

import Vue from 'vue';

function isDomain(){
  var url = window.location.host;
  try {
      var urlArr = url.split(".");
      if(urlArr[2]=='de' || urlArr[2]=='fr' || urlArr[2]=='jp' || urlArr[2]=='es'){
          return true;
      }else if(location.host.indexOf("com.br")>-1) {
          return true;
      }
  }catch(e){

  }
  return false;
};
function getLang(){
  var url = window.location.host;
  var lang = getCookie('lang');
  if(!lang){
      lang = localStorage.getItem('lang')
  }
  try {
      var urlArr = url.split(".");
      if(urlArr[2]=='de' || urlArr[2]=='fr' || urlArr[2]=='jp' || urlArr[2]=='es'){
          lang=urlArr[2];
      }else if(location.host.indexOf("com.br")>-1) {
          lang='pt';
      }
  }catch(e){

  }
  return lang;
};
// if(!getLocalStorage("_device_id") && getLocalStorage("_device_id")!="undefined"){
  getzw();
// }

async function requestIdleCallback2() {
  let visitorId = getLocalStorage('_device_id');
  if (!visitorId) {
    const fp = await fingerprintjs.load();
    const result = await fp.get();
    visitorId = result.visitorId;
    setLocalStorage('_device_id', visitorId);  // 存储到 sessionStorage
  }

  console.log('RequestIdleCallback', visitorId);
  return visitorId;
}

async function getzw() {
  let fingerprint;
  await requestIdleCallback2().then((res) => {
    fingerprint = res;
  });
  console.log(isDomain,34)
  if(isDomain()){
      fingerprint=fingerprint.slice(0, -2)+getLang()
  }
  setLocalStorage("_device_id", fingerprint);
  // return fingerprint;
}


// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
  // headers: {
  //   "Access-Control-Allow-Origin": "*",
  //   "Content-Type": "application/json; charset=utf-8"
  // }
})

// request interceptor
service.interceptors.request.use(
  async config => {
    
    // if (store.getters.token) {
    //   config.headers['Authorization'] = 'Bearer ' + getToken();
    // }

    // 验证 token 是否过期,必须是业务场景提前判定，不是请求过程中生成或创建token
    // await VerificationToken();
    getLocalStorage("P-Token") ? config.headers['Authorization'] = 'Bearer ' + getLocalStorage("P-Token") : null;
    if (!config.data) {
      config.data = {};
    }
    config.data.e_id = getLocalStorage("_device_id");//await getzw();
  
    // const jsonObject = { ...config.data, e_id: await getzw() }; // 包含新参数的 JSON 对象
    // const signatureGenerator = new SignatureGenerator(jsonObject, config.data.e_id); // 创建 SignatureGenerator 实例
    // const sign = signatureGenerator.generateSignature(); // 生成签名
  
    // config.data.sign = sign.sign; // 将签名参数添加到 config.data
    return config;
  },
  error => {
    // do something with request error
    
    return Promise.reject(error)
  },
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    var nowTime = new Date().getTime();
    var responseTime = response.headers['x-response-time'];
    setLocalStorage('errorTime', responseTime - nowTime);
    // if the custom code is not 20000, it is judged as an error.
    if (response.status != 200) {
      // 401: Other clients logged in; 500: Token expired;
      if (res.code === 20000 || res.code === 20005) {
        if (process.env.NODE_ENV != 'production') {
          //console.log("re-login", res)
          console.info("访问路径", process.env.VUE_APP_Logout)
          return
        }
      }
      return Promise.reject(res)
    } else {
      if(res.code == 403){
        removeToken();
        // Message({
        //   message: window.i18n.t("login.loginFailure"),
        //   type: 'error'
        // });        
        // CreateNewToken()
        return res;
      }
      if (res.code === 20005) {
        removeToken();
        removeAllLocalStorage()
      }
      return res
    }
  },
  error => {
    console.log("错误监听",Vue.prototype.$hasShownToast);
    return Promise.reject(error)
  }
)

export default service
